import global from './global.json';
import button from './button.json';
import header from './header.json';

export default {
  global,
  button,
  header,
};
